import { render } from "react-dom";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import baseTheme from "./theme";
import "typeface-roboto";
import Root from "./containers/root";
import "./globalStyle.css";
import rootSaga from "./sagas";
import configureAppStore from "./store/store";
import * as plurals from "make-plural/plurals";
import { messages as enMsgs } from "../../../locale/en/messages";
import { messages as heMsgs } from "../../../locale/he/messages";
import { I18nProvider } from "@lingui/react";
import { i18n } from "@lingui/core";

i18n.loadLocaleData("en", { plurals: plurals.en });
i18n.loadLocaleData("he", { plurals: plurals.he });

i18n.load("en", enMsgs);
i18n.load("he", heMsgs);

const language = document.getElementsByTagName("html")[0].getAttribute("lang");
i18n.activate(language);

const store = configureAppStore(window.__INITIAL_STATE__);
store.runSaga(rootSaga);

const direction = language === "he" ? "rtl" : "ltr";
const themeWithDirection = { ...baseTheme, direction };
const theme = createMuiTheme(themeWithDirection);


render(
  <I18nProvider i18n={i18n}>
    <MuiThemeProvider theme={theme}>
      <Root store={store} />
    </MuiThemeProvider>
  </I18nProvider>,
  document.getElementById("root"),
);
